import { api } from "services";
import { LoginRequest } from ".";

import { Login } from "./types";

export const login = async (data: LoginRequest): Promise<Login> => {
  const resp = await api.post("/auth/login", data);
  return resp.data;
};
